import type { Metrics as M } from '../types';

/** Compact metrics strip — sized for iPhone header. */
export function Metrics({ metrics }: { metrics: M | null }) {
  if (!metrics) return null;
  const pct = Math.round(metrics.responseRate * 100);
  return (
    <div className="grid grid-cols-3 gap-1">
      <Stat label="Response" value={`${pct}%`} sub={`${metrics.submitted}/${metrics.expected}`} />
      <Stat label="Issues" value={String(metrics.issuesYTD)} sub="YTD" />
      <Stat label="Shipped" value={String(metrics.shippedYTD)} sub="YTD" accent />
    </div>
  );
}

function Stat({ label, value, sub, accent }: {
  label: string; value: string; sub?: string; accent?: boolean;
}) {
  return (
    <div className={`px-2 py-1 border ${accent ? 'border-coast-blue' : 'border-coast-hairline'}`}>
      <div className="text-[9px] uppercase tracking-widest text-coast-muted leading-none">{label}</div>
      <div className={`font-heading text-lg leading-tight ${accent ? 'text-coast-blue' : ''}`}>
        {value}
      </div>
      {sub && <div className="text-[9px] text-coast-muted leading-none">{sub}</div>}
    </div>
  );
}
